export default __webpack_public_path__ + "static/media/caret-down.ef43f1e9.svg";